import config from 'config';
import { settings } from 'core';
import { HeaderLogo } from 'ui/components';
import { useRouterCurrent } from 'ui/containers/SectionBuilder/hooks';

import { Logo } from '../../../Logo';

const HeaderMenuWidget = () => {
  const path = settings.hooks.useHomepage();
  const { isPublic } = useRouterCurrent();

  return (
    <HeaderLogo to={isPublic ? '/' : path} data-label={config.app.name}>
      <Logo />
    </HeaderLogo>
  );
};

export default HeaderMenuWidget;
